module.exports = __webpack_public_path__ + "files/b49aef936d34dd80e5736fae725d6f28.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/ubuntu-bolditalic-webfont.eot
 ** module id = 434
 ** module chunks = 0
 **/